import React from 'react'
import Post from "./Post"
import '../Post.css'

function Posts() {
    return (
        <div>
            <Post name="Samuel Vimes" username="justiceserved" image="https://bulma.io/images/placeholders/1280x960.png"/>
            <Post name="Rincewind" username="rincethewizz" content="Luck is my middle name. Mind you, my first name is 'Bad'."/>
            <Post name="Carrot Ironfoundersson" username="cplcarrot" image="https://bulma.io/images/placeholders/1280x960.png" content="An appointment is an engagement to see someone, while a morningstar is a large lump of metal used for viciously crushing skulls. It is important not to confuse the two, isn't it?"/>
        </div>
    )
}

export default Posts